export const styleSprite = {
  normal: 'mapbox://sprites/mapbox/light-v10',
  satelite: 'mapbox://sprites/mapbox/satellite-streets-v11',
};
